<template>
<div class="container no-padding">
  <div class="loading-block" v-if="loading"><img src="/img/loader.svg" /></div>
  <div class="header">
    <img src="/img/briskly.svg" alt="" />
    <br/>
    <span class="fs30 medium">Ваша покупка</span>
  </div>
  <div class="content">
    <div class="order-list-wrapper" style="margin-top: 20px;max-height:483px;" id="scrollElem">
      <div v-for="item in $store.state.order.items" class="order-item">
        <div class="item-info">
          <span class="item-name">{{item.item.name}}</span>
          <span class="item-properties">{{item.item.unit}}</span>
        </div>
        <div class="item-price"><span class="old-price" v-if="item.price !== item.item.price">{{item.item.price}} ₽</span><span>{{item.price}} ₽</span></div>
        <a class="close" @click.prevent="decrease(item)"></a>
      </div>
    </div>
  </div>
  <div class="order-cost">
    <a class="close" href="#" @click.prevent="cancelPayment"></a>
    <a href="#" @click.prevent="payByCard" style="color: #0D5020;text-transform:uppercase;" class="fs36 medium">Оплатить {{$store.state.order.total_amount}} ₽</a>
    <!-- <router-link :to="'/pay?action=pay&store_terminal_key='+key+'&order_id='+$store.state.order.id" style="color: #0D5020;text-transform:uppercase;"
                 class="fs36 medium">
      Оплатить {{$store.state.order.total_amount}} ₽
    </router-link> -->
  </div>
</div>
</template>

<script>
export default {
  name: 'Basket',
  data() {
    return {
      key: localStorage.getItem('devices_channel_key'),
      loading: false,
    };
  },
  created() {},
  mounted() {
    clearInterval(this.$store.state.timeout);
    let elem = this;
    this.$store.state.timeout = setInterval(function() {
      elem.$store.state.timeSpent += 1000;
      if (elem.$store.state.timeSpent > elem.$store.state.timeoutTime) {
        clearInterval(elem.$store.state.timeout);
        elem.$router.push('/');
      }
    }, 1000);
  },
  methods: {
    cancelPayment() {
      this.$router.push('/');
    },
    payByCard() {
      this.loading = true;
      this.$api
        .post('/order/pay-by-card-token/', {
          key: this.key,
        })
        .then(response => {
          this.loading = false;
          this.$router.push('/success');
        })
        .catch(error => {
          this.$alert(response.error.message);
        });
    },
    decrease(item) {
      this.loading = true;
      this.$api
        .post('/order/item/decrease/', {
          key: this.key,
          order_item_id: item.id,
        })
        .then(response => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
body {
  overflow-y: auto;
}
.header {
  z-index: 2020;
  display: block;
  text-align: center;
  margin-top: 54px;
  height: 148px;
  padding-top: 45px;
}
.header span {
  color: #fff;
  display: block;
  margin-top: -10px;
}
.header img {
  width: 160px;
  text-align: center;
  display: block;
  margin: 0 auto;
}
.content {
  z-index: 2022;
}
</style>
